import { PaperIcon } from '@/components/ui/icons/PaperIcon';
import { Column } from '@/components/ui/layout/Column';
import { Row } from '@/components/ui/layout/Row';

import { AnalysisAccordion } from '../../common/AnalysisAccordion';

export const PreviewPanelSkeleton = () => {
  return (
    <Column
      gap="md"
      role="status"
      id="preview-section"
      className="animate-pulse"
    >
      <Row justify="start">
        <PaperIcon
          size={24}
          className="text-neutralText dark:text-neutralText-dark"
        />
        <div className="h-6 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
      </Row>

      <Row id="risk-section" justify="between">
        <div className="h-6 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
        <div className="h-6 w-16 rounded-full bg-gray-200 dark:bg-gray-700"></div>
      </Row>

      <Column>
        <AnalysisAccordion
          title="Metadonnées"
          variant="metadata"
          content={''}
        />

        <AnalysisAccordion title="Tests" variant="tests" content={''} />
      </Column>
    </Column>
  );
};
